<template>
  <div class="FinalGroup">
    <my_image :src="title" :width="'50vw'"></my_image>
    <div class="tip">点击视频观看复赛规则介绍</div>
    <my_video :v="v" :inputStyle="videoStyle"></my_video>
    <span title="比赛开始时按钮将自动刷新，无需手动刷新页面"><my_button :value="'进入比赛'" :inputStyle="buttonStyle" :disable="disable" @click.native="jump"></my_button></span>
    <vue_markdown :source="mdfile" id="rule"></vue_markdown>
  </div>
</template>

<script>
 // @ is an alias to /src
 import MyImage from '@/components/Image.vue';
 import MyVideo from '@/components/Video.vue';
 import MyButton from '@/components/Button.vue';
 import VueMarkdown from 'vue-markdown'
 import rulemd from 'raw-loader!@/assets/markdown/finalGroupRule.md';
 import bgImg from '@/assets/image/final/group-bg.jpg'
 import moment from 'moment'
 export default {
   name: '',
   computed: {
     title () {
       /* return 'https://assets.koudashijie.com/images/magic-rush-bg.jpeg'*/
       return bgImg
     },
     v() {
       return {
         src:'https://assets.koudashijie.com/videos/AI%E4%B8%96%E9%9D%92%E8%B5%9B%E5%A4%8D%E8%B5%9B%E8%A7%86%E9%A2%91%EF%BC%88%E6%97%A0%E7%BD%91%E5%9D%80%EF%BC%89.mp4'
       }
     },
     videoStyle() {
       return {
         width: '40vw',
         'margin-top': 0,
         height: 'auto'
       }
     },
     mdfile() {
       return rulemd
     },
     buttonStyle() {
       return {
         'border-radius': '5px',
         'margin-top': '2vw',
         'width': '8em'
       }
     },
     myClassroom() {
       return this.$store.state.classrooms[this.$store.state.auth.classroom[0].classroom_id]
       /* return this.$store.state.auth.classroom*/
     }

   },
   data () {
     return {
       disable: true,
       interval: null,
       user: null
     }
   },
   methods: {
     jump() {
       let user = this.user ||  this.$store.state.auth.user
       let redirect = this.myClassroom.entry
       let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
       window.open(url)
     },
     correctTime() {
       return moment(+new Date() + this.$store.state.timeDelay)
     },
   },
   mounted() {
     let myClassroom = this.myClassroom
     let user = this.user ||  this.$store.state.auth.user
     if(!user || !myClassroom)
       {
         this.$router.push({name: 'frontpage'})
       }
     let that = this
     let startTime = moment(myClassroom.begin_time)
     let timeLimit1 = moment(myClassroom.begin_time).subtract(4, 'minutes');
     let timeLimit2 = moment(myClassroom.begin_time).subtract(3, 'minutes');
     let endTime = moment(myClassroom.end_time)
     let nowTime = this.correctTime()
     console.log(startTime)
     if(nowTime.isBefore(endTime))
       {
         if(nowTime.isAfter(startTime))
           {
             that.disable = false
           }
         else{
           that.interval = setInterval(function() {
             if(that.correctTime().isAfter(timeLimit1))
               {
                 clearInterval(that.interval)
                 that.interval = setInterval(function() {

                   if(that.correctTime().isAfter(timeLimit2))
                     {
                       clearInterval(that.interval)
                       that.disable = false
                     }
                 }, 5000)
               }
           }, 60000)
         }
       }
   },
   components: {
     my_image: MyImage,
     my_video: MyVideo,
     my_button: MyButton,
     vue_markdown: VueMarkdown,
   }
 }
</script>

<style scoped>
 .FinalGroup{
   margin-top: 6.5625vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   font-size: 1.3vw;
 }
 .tip{
   color: #F17C67;
   font-weight: 500;
   font-size: 26px;
   margin-top: 20px;
 }
 #rule{
   width: 50vw;
 }
</style>